'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DragSource } from 'react-dnd-compat';
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import { draggingStarted as draggingStartedAction, draggingStopped as draggingStoppedAction } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { getHoveredResizeHandleType } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import SolidColumnGridLine from 'layout-dnd-components/SolidColumnGridLine';
import { dragTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { layoutSectionHoverPositionsFrozen, layoutSectionHoverPositionsThawed } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { calculateResizeSteps } from 'InpageEditorUI/lib/layoutSection/resizeHandleHelpers';
import { getIsAnythingSelected } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledResizeHandle = styled.div.withConfig({
  displayName: "LayoutSectionResizeHandle__StyledResizeHandle"
})([".hs-private.hs-private.hs-private &{position:absolute;z-index:3;cursor:col-resize;}"]);
const dragSource = {
  beginDrag(props) {
    const {
      type,
      leftColumn,
      rightColumn,
      draggingStarted,
      setDragging
    } = props;
    setDragging(true);
    const resizeSteps = calculateResizeSteps(leftColumn, rightColumn);
    const dragItem = {
      type,
      resizeSteps,
      leftColumnId: leftColumn.id,
      rightColumnId: rightColumn.id
    };
    draggingStarted(dragItem);
    return dragItem;
  },
  canDrag(props) {
    return !props.isAnythingSelected;
  },
  endDrag(props, monitor) {
    props.setDragging(false);
    props.draggingStopped(monitor.getItem(), monitor.didDrop());
  }
};
const dragCollect = monitor => {
  return {
    isDragging: monitor.isDragging()
  };
};
const mapStateToProps = (state, ownProps) => {
  return {
    isAnythingSelected: getIsAnythingSelected(state),
    isResizeHandleHovered: getHoveredResizeHandleType(state) === ownProps.type
  };
};

/**
 * @param {Function} props.connectDragPreview (required)
 * @param {Function} props.connectDragSource (required)
 * @param {boolean} props.shouldHide (required)
 * @param {boolean} props.isDragging (required)
 * @param {boolean} props.isAnythingSelected (required)
 * @param {boolean} props.isResizeHandleHovered (required)
 * @param {number} props.gutterTop (required)
 * @param {number} props.gutterLeft (required)
 * @param {number} props.gutterHeight (required)
 * @param {number} props.gutterWidth (required)
 * @param {Object} props.leftColumn (optional)
 * @param {Object} props.rightColumn (optional)
 * @param {string} props.type (required)
 * @param {Function} props.layoutSectionHoverPositionsFrozen (required)
 * @param {Function} props.layoutSectionHoverPositionsThawed (required)
 */
class LayoutSectionResizeHandle extends Component {
  constructor(props) {
    super(props);
    this.getGridlineLeftPos = this.getGridlineLeftPos.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleNextMouseUpAnywhere = this.handleNextMouseUpAnywhere.bind(this);
  }
  componentDidMount() {
    const {
      connectDragPreview
    } = this.props;
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }
  getGridlineLeftPos() {
    const {
      isDragging,
      isResizeHandleHovered,
      gutterWidth
    } = this.props;
    const roundedLeft = Math.round(gutterWidth / 2);
    const isWiderLine = isDragging || isResizeHandleHovered; // 2px when active

    // Attempting to center the grid under the resize handle, might need tweaking
    if (isWiderLine || roundedLeft % 2 === 0) {
      return roundedLeft;
    }
    return roundedLeft - 0.5;
  }
  handleMouseDown() {
    this.props.layoutSectionHoverPositionsFrozen();
    window.addEventListener('mouseup', this.handleNextMouseUpAnywhere);
  }
  handleNextMouseUpAnywhere() {
    this.props.layoutSectionHoverPositionsThawed();
    window.removeEventListener('mouseup', this.handleNextMouseUpAnywhere);
  }
  render() {
    const {
      connectDragSource,
      isDragging,
      isResizeHandleHovered,
      shouldHide,
      gutterTop,
      gutterLeft,
      gutterHeight,
      gutterWidth,
      type
    } = this.props;
    const columnResizeHandle = /*#__PURE__*/_jsx(SolidColumnGridLine, {
      height: gutterHeight,
      isActive: isDragging || isResizeHandleHovered,
      left: this.getGridlineLeftPos(),
      top: 0
    });
    return /*#__PURE__*/_jsx(StyledResizeHandle, {
      ref: connectDragSource,
      onMouseDown: this.handleMouseDown,
      style: {
        display: shouldHide ? 'none' : 'block',
        top: gutterTop,
        left: gutterLeft,
        width: gutterWidth,
        height: gutterHeight
      },
      children: /*#__PURE__*/_jsx("div", {
        "data-selenium": type,
        children: columnResizeHandle
      })
    });
  }
}
LayoutSectionResizeHandle.contextType = TourContext;
export default connect(mapStateToProps, {
  draggingStarted: draggingStartedAction,
  draggingStopped: draggingStoppedAction,
  layoutSectionHoverPositionsFrozen,
  layoutSectionHoverPositionsThawed
})(DragSource(dragTypes.RESIZE_HANDLE, dragSource, dragCollect)(LayoutSectionResizeHandle));